import {zodResolver} from "@hookform/resolvers/zod";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import ErrorMessage from "../../../components/ErrorMessage";
import base64ToFile from "../../../services/base64ToFile";

const ContactCard = ({contact, schema, onUpdate, onDelete}) => {
  const {id, imageBase64, imageTag: tag, email, descriptionEn} = contact;

  const [imagePreview, setImagePreview] = useState(
      `data:image/jpeg;base64,${imageBase64}`
  );
  const [imageTag, setImageTag] = useState(tag);

  const {
    register,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm({
    resolver: zodResolver(schema),
    initialValue: contact,
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setValue("imageBase64", file);
    setImageTag(file.name);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (data) => {
    const {descriptionEn, email, imageBase64} = data;
    console.log(data);

    const formData = new FormData();
    formData.append("image", imageBase64);
    formData.append("email", email);
    formData.append("descriptionEn", descriptionEn);

    onUpdate(formData, id);
  };

  useEffect(() => {
    setValue("imageBase64", base64ToFile(imagePreview));
    setValue("descriptionEn", descriptionEn);
    setValue("email", email);
  }, []);

  return (
      <div className="custom-card">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <div className="left mb-1">
              <div className="image-uploader">
                <label className="icon-update-btn" htmlFor={`iconUploader${id}`}>
                  <i className="fa fa-pencil"></i>
                </label>
                <input
                    id={`iconUploader${id}`}
                    className="d-none"
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    {...register("imageBase64", {
                      onChange: handleImageChange,
                    })}
                />
              </div>
              <img src={imagePreview} alt={imageTag}/>
            </div>
            {errors.imageBase64 && (
                <ErrorMessage message={errors.imageBase64.message}/>
            )}
          </div>
          <div className="right">
            <div className="mb-4">
              <div className="form__div--textarea mb-0">
              <textarea
                  className="form__textarea"
                  {...register("descriptionEn")}
              />
                <label htmlFor="" className="textarea-form__label">
                  Description
                </label>
              </div>
              {errors.descriptionEn && (
                  <ErrorMessage message={errors.descriptionEn.message}/>
              )}
            </div>
            <div className="form__div-container">
              <div className="form__div">
                <input
                    type="email"
                    className="form__input"
                    {...register("email")}
                />
                <label htmlFor="" className="form__label">
                  Email
                </label>
              </div>
              {errors.email && <ErrorMessage message={errors.email.message}/>}
            </div>
            <div className="text-right">
              <button
                  type="button"
                  onClick={() => onDelete(id)}
                  className="delete-btn"
              >
                Delete
              </button>
              <button type="submit" className="save-btn ml-2">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
  );
};

export default ContactCard;
